import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from '../../../animations/index';

export type ContentEmptyVariant = 'empty' | 'no-results' | 'error';

/**
 * Message shown in place of data: `empty` (nothing created yet),
 * `no-results` (filters match nothing) or `error` (loading failed, announced
 * as an alert). Slots: `.empty-heading`, `.empty-subheading`, `.empty-actions`.
 */
@Component({
  selector: 'app-content-empty-cabinet',
  templateUrl: './content-empty.component.html',
  styleUrl: './content-empty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
  host: {
    '[attr.role]': "variant() === 'error' ? 'alert' : null",
    '[class.variant-error]': "variant() === 'error'",
  },
})
export class ContentEmptyCabinetComponent {
  readonly variant = input<ContentEmptyVariant>('empty');
}
